import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

export const QuestionActionButtons = ({ onRespond, onSkip, hideSkipBtn, hideRespondBtn }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      {!hideRespondBtn && (
        <button 
          className={styles.respondButton}
          onClick={onRespond}
        >
          {t('chatsocket.question.answer')}
        </button>
      )}
      {!hideSkipBtn && (

        <button 
          className={styles.skipButton}
          onClick={onSkip}
        >
        {t('chatsocket.question.skip_question')}
        </button>
      )}
    </div>
  );
};
